import React from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';
import FormikCollegeSelector from '../formik-college-selector';
import FormikDropdown from '../../../components/formik-dropdown';
import {titleize} from '../../../../shared/utils';

const LIST_TYPES = [
  'national',
  'liberal_arts',
  'regional_midwest',
  'regional_north',
  'regional_south',
  'regional_west',
];

const ListTypeSelector = (): React.ReactElement => (
  <FormikDropdown
    name="listType"
    placeholder="List type"
    options={LIST_TYPES.map((listType) => ({
      _id: listType,
      value: listType,
      text: titleize(listType, true),
    }))}
  />
);

const columns: ColumnSettings[] = [
  {
    name: 'collegeName',
    title: 'College Name',
    sortable: true,
    editable: false,
  },
  {
    name: 'rank',
    title: 'Rank',
    sortable: true,
    type: 'number',
  },
  {
    name: 'year',
    title: 'Year',
    sortable: true,
    type: 'number',
  },
  {
    name: 'listType',
    title: 'List Type',
    sortable: true,
    renderValue: (value): string => titleize(value, true),
    FormField: ListTypeSelector,
  },
  {
    name: 'unitId',
    title: 'College',
    sortable: true,
    FormField: FormikCollegeSelector,
    hidden: true,
  },
];

const UsNewsRanks = (): React.ReactElement => (
  <div>
    <h1 className="shared-font headline">US News Ranks</h1>
    <EditableTable
      basePath="/v1/admin/us-news-ranks"
      defaultSortKey="collegeName"
      columns={columns}
      identifier="us-news-ranks"
      allowBulkEdit
    />
  </div>
);

export default UsNewsRanks;
